angular.module 'app'
.controller 'AppController', ($timeout, $rootScope, $scope, $http, $state, $ionicPopup, $ionicLoading, config, activeUser, ionicMaterialInk) ->
  
  $rootScope.$on '$routeChangeStart', ->
    $ionicLoading.show()

  $rootScope.$on '$routeChangeSuccess', ->
    $ionicLoading.hide()


  $scope.appConfig =
    baseUrl: config.api.baseUrl
    userInfo: activeUser.user
    homepage: activeUser.homepage
    
  
  $scope.toHome = ->
    $state.go("app.home", {})
  $scope.toAuthenticationInfo = ->
    $state.go("app.authentication_info", {status: '0'})
  
  $timeout (->
    ionicMaterialInk.displayEffect()
  ), 1000
  

  
